export function getYouTubeEmbedUrl(url: string): string {
  try {
    const parsed = new URL(url);
    let videoId = '';
    if (parsed.hostname.includes('youtu.be')) {
      videoId = parsed.pathname.slice(1);
    } else {
      videoId = parsed.searchParams.get('v') ?? parsed.pathname.split('/').pop() ?? '';
    }
    return `https://www.youtube.com/embed/${videoId}`;
  } catch {
    return url;
  }
}
